/**
 * Copyright (C) Siemens AG 1996-2026 ALL RIGHTS RESERVED.
 */

export const ID_SHORT_TRANSLATION_MAP: Record<string, string> = {
  URIOfTheProduct: 'dpp.nameplate.uri_of_the_product',
  ManufacturerName: 'dpp.nameplate.manufacturer_name',
  ManufacturerProductDesignation:
    'dpp.nameplate.manufacturer_product_designation',
  AddressInformation: 'dpp.nameplate.address_information',
  RoleOfContactPerson: 'dpp.nameplate.role_of_contact_person',
  NationalCode: 'dpp.nameplate.national_code',
  Language: 'dpp.nameplate.language',
  TimeZone: 'dpp.nameplate.time_zone',
  CityTown: 'dpp.nameplate.city_town',
  Company: 'dpp.nameplate.company',
  Department: 'dpp.nameplate.department',
  Phone: 'dpp.nameplate.phone',
  TelephoneNumber: 'dpp.nameplate.telephone_number',
  TypeOfTelephone: 'dpp.nameplate.type_of_telephone',
  AvailableTime: 'dpp.nameplate.available_time',
  Fax: 'dpp.nameplate.fax',
  FaxNumber: 'dpp.nameplate.fax_number',
  TypeOfFaxNumber: 'dpp.nameplate.type_of_fax_number',
  Email: 'dpp.nameplate.email',
  EmailAddress: 'dpp.nameplate.email_address',
  PublicKey: 'dpp.nameplate.public_key',
  TypeOfEmailAddress: 'dpp.nameplate.type_of_email_address',
  TypeOfPublicKey: 'dpp.nameplate.type_of_public_key',
  IPCommunication__00__: 'dpp.nameplate.ip_communication',
  AddressOfAdditionalLink: 'dpp.nameplate.address_of_additional_link',
  TypeOfCommunication: 'dpp.nameplate.type_of_communication',
  Street: 'dpp.nameplate.street',
  Zipcode: 'dpp.nameplate.zipcode',
  POBox: 'dpp.nameplate.po_box',
  ZipCodeOfPOBox: 'dpp.nameplate.zip_code_of_po_box',
  StateCounty: 'dpp.nameplate.state_county',
  NameOfContact: 'dpp.nameplate.name_of_contact',
  FirstName: 'dpp.nameplate.first_name',
  MiddleNames: 'dpp.nameplate.middle_names',
  Title: 'dpp.nameplate.title',
  AcademicTitle: 'dpp.nameplate.academic_title',
  FurtherDetailsOfContact: 'dpp.nameplate.further_details_of_contact',
  ManufacturerProductRoot: 'dpp.nameplate.manufacturer_product_root',
  ManufacturerProductFamily: 'dpp.nameplate.manufacturer_product_family',
  ManufacturerProductType: 'dpp.nameplate.manufacturer_product_type',
  OrderCodeOfManufacturer: 'dpp.nameplate.order_code_of_manufacturer',
  ProductArticleNumberOfManufacturer:
    'dpp.nameplate.product_article_number_of_manufacturer',
  SerialNumber: 'dpp.nameplate.serial_number',
  YearOfConstruction: 'dpp.nameplate.year_of_construction',
  DateOfManufacture: 'dpp.nameplate.date_of_manufacture',
  HardwareVersion: 'dpp.nameplate.hardware_version',
  FirmwareVersion: 'dpp.nameplate.firmware_version',
  SoftwareVersion: 'dpp.nameplate.software_version',
  CountryOfOrigin: 'dpp.nameplate.country_of_origin',
  UniqueFacilityIdentifier: 'dpp.nameplate.unique_facility_identifier',
  CompanyLogo: 'dpp.nameplate.company_logo',
  Markings: 'dpp.nameplate.markings',
  MarkingName: 'dpp.nameplate.marking_name',
  DesignationOfCertificateOrApproval:
    'dpp.nameplate.designation_of_certificate_or_approval',
  IssueDate: 'dpp.nameplate.issue_date',
  ExpiryDate: 'dpp.nameplate.expiry_date',
  MarkingFile: 'dpp.nameplate.marking_file',
  MarkingAdditionalText: 'dpp.nameplate.marking_additional_text',
  AssetSpecificProperties: 'dpp.nameplate.asset_specific_properties',
  ArbitraryProperty: 'dpp.nameplate.arbitrary_property',
  ArbitraryMLP: 'dpp.nameplate.arbitrary_mlp',
  ArbitraryFile: 'dpp.nameplate.arbitrary_file',
  GuidelineSpecificProperties: 'dpp.nameplate.guideline_specific_properties',
  GuidelineForConformityDeclaration:
    'dpp.nameplate.guideline_for_conformity_declaration',
};
